/* Pips sit on a 3 × 3 grid: 10 px pips at 10, 23 and 36 px on a 56 px die. */
.die {
  --pip: 10px;
  --first: 10px;
  --step: 13px;

  position: relative;
  display: inline-block;
  flex: none;
  width: 56px;
  height: 56px;
  border-radius: var(--zumpo-radius-12);
  background: var(--zumpo-paper);
  box-shadow:
    inset 0 0 0 1px var(--zumpo-line),
    var(--zumpo-shadow-cell-edge);
}

/* 6 px pips at 6, 13 and 20 px on a 32 px die. */
.compact {
  --pip: 6px;
  --first: 6px;
  --step: 7px;

  width: 32px;
  height: 32px;
  border-radius: var(--zumpo-radius-8);
}

.pip {
  position: absolute;
  top: calc(var(--first) + var(--row) * var(--step));
  left: calc(var(--first) + var(--column) * var(--step));
  width: var(--pip);
  height: var(--pip);
  border-radius: 50%;
  background: var(--zumpo-ink);
}

/* Strokes sit inside, as in Figma, so every state keeps the die's size. */
.counted {
  background: var(--zumpo-lime);
  box-shadow: inset 0 0 0 2px var(--zumpo-ink);
}

.wild {
  background: var(--zumpo-peach);
  box-shadow: inset 0 0 0 2px var(--zumpo-ink);
}

.dim {
  background: var(--zumpo-cream);
  box-shadow: inset 0 0 0 1px var(--zumpo-line);
}

.dim .pip {
  opacity: 0.35;
}

/* Face down, as a Minesweeper cell nobody has opened. */
.hidden {
  background: var(--zumpo-blue);
  box-shadow: var(--zumpo-shadow-cell-edge);
}

/* Figma dashes the empty slot 6 on, 4 off; a dashed border is the nearest CSS has. */
.empty {
  border: 2px dashed var(--zumpo-line);
  background: none;
  box-shadow: none;
}
